<template>
  <section class="login-container">
    <div class='login-wrap'>
      <div class="img-wrap">
        <img src="../../assets/img/login-bg.png" fit="contain"/>
      </div>
      <div class="form-wrap">
        <div class="img-logo">
          <img src="../../assets/img/logo.png" fit="contain"/>
        </div>
        <el-form
          ref="form"
          :model="form"
          :rules='rules'
        >
          <el-form-item prop='identity'>
            <el-input v-model="form.identity" :autofocus="true" placeholder="请输入您的用户名" @focus="onFocusUsername" @blur="onBlurUsername" @keyup.enter.native="handleConfirm" :class="{'is-focus': focus === 'username'}">
              <jee-icon iconClass='denglutouxiang' slot="prefix"/>
            </el-input>
          </el-form-item>
          <el-form-item prop='desStr'>
            <el-input v-model="form.desStr" :show-password="showPassword" placeholder="请输入您的密码" @focus="onFocusPassword" @blur="onBlurPassword" @keyup.enter.native="handleConfirm" :class="{'is-focus': focus === 'password'}">
              <jee-icon iconClass='denglumima' slot="prefix"/>
              <jee-icon :iconClass="showPassword?'htmal5icon08':'htmal5icon09'" slot="suffix" @click="showPassword = !showPassword"/>
            </el-input>
          </el-form-item>
          <el-form-item prop='captcha' v-if="nextNeedCaptcha">
            <el-input v-model="form.captcha" placeholder="请输入验证码"  @focus="onFocusCaptcha" @blur="onBlurCaptcha" @keyup.enter.native="handleConfirm" :class="{'is-focus': focus === 'captcha'}">
              <jee-icon iconClass='yanzhengma' slot="prefix"/>
              <img :src="captchaSrc" alt="" slot="suffix" @click="fetchCaptcha">
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class='submit' @click="handleConfirm">
              <span class='loading' v-if='loading'>
                <jee-icon iconClass='jiazaizhong'/>
              </span>
              <span v-if='loading' class='logining'>登录中...</span>
              <span v-else>登录</span>
            </div>
            <em class="register" style="float: left;display: block;" @click="resetPw">忘记密码</em>
            <em class="register" style="float: right;display: block;" @click="goToRegister">立即注册</em>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <form-dialog
      title='投稿人注册'
      ref="addDialog"
      :loading="addFormLoading"
      :form="addForm"
      :rules="addRules"
      :buttons="addButtons"
      :formItems="addFormItems"
      v-on:handleConfirm="handleConfirmAdd"
    ></form-dialog>
    <form-dialog
      title='忘记密码'
      ref="resetDialog"
      :loading="resetFormLoading"
      :form="resetForm"
      :rules="resetRules"
      :buttons="resetButtons"
      :formItems="resetFormItems"
      v-on:handleConfirm="handleConfirmReset"
    ></form-dialog>
    <password-dialog
      ref="passwordDialog"
      @handleSubmit="handleSubmit"
    ></password-dialog>
  </section>
</template>
<script>
import PasswordDialog from '@/components/dialog/PasswordDialog'
import { desEncrypt, desDecrypt } from '@/utils'
import register from './register'

import {
  mapActions
} from 'vuex'

export default {
  name: 'login',
  components: {
    PasswordDialog
  },
  mixins: [register],
  data () {
    return {
      loading: false,
      showPassword: true,
      nextNeedCaptcha: false,
      captchaSrc: '',
      focus: '',
      form: {
        identity: '',
        desStr: '',
        captcha: '',
        sessionId: ''
      },
      rules: {
        identity: [
          this.$rules.required()
        ],
        desStr: [
          this.$rules.required()
        ],
        captcha: [
          this.$rules.required()
        ]
      }
    }
  },
  methods: {
    desEncrypt,
    desDecrypt,
    ...mapActions('app', ['fetchLogin']),
    onFocusUsername () {
      this.focus = 'username'
    },
    onBlurUsername () {
      this.focus = ''
    },
    onFocusPassword () {
      this.focus = 'password'
    },
    onBlurPassword () {
      this.focus = ''
    },
    onFocusCaptcha () {
      this.focus = 'captcha'
    },
    onBlurCaptcha () {
      this.focus = ''
    },
    fetchCaptcha () {
      this.$request.fetchCode().then(res => {
        if (res.code === 200) {
          this.captchaSrc = 'data:image/jpeg;base64,' + res.data.img
          this.form.sessionId = res.data.sessionId
        }
      })
    },
    handleConfirm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const data = Object.assign({}, this.form)
          this.fetchLogin(data).then(res => {
            this.loading = false
            if (res.code === 200) {
              if (res.data.nextNeedCaptcha) {
                this.nextNeedCaptcha = true
                this.fetchCaptcha()
              } else if (res.data.needChangePassword) {
                this.$refs.passwordDialog.showDialog()
              } else {
                this.onNavgate()
              }
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    handleSubmit () {
      this.onNavgate()
    },
    onNavgate () {
      let { redirect } = this.$route.query
      if (redirect) {
        // console.log('重定向到：', redirect)
        if (redirect.indexOf('/workplace') !== -1) {
          window.sessionStorage.setItem('isLogin', 'true')
        }
        this.$router.replace(unescape(redirect))
      } else {
        // console.log('重定向到工作台')
        this.$router.replace('/workplace')
        window.sessionStorage.setItem('isLogin', 'true')
      }
    },
    goToRegister () {
      this.$refs.addDialog.showDialog()
      // this.$router.push({ name: 'register', query: {} })
    },
    resetPw () {
      this.$refs.resetDialog.showDialog()
    }
  },
  activated () {
    this.$request.fetchLogout().then(res => {
    }).catch(() => {})
  },
  mounted () {
    this.$request.fetchLogout().then(res => {
    }).catch(() => {})
  }
}
</script>
<style lang="scss">
.login-container{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:#F2F6F7;
  .login-wrap{
    width: 973px;
    background-color: #ffffff;
    box-shadow:0px 5px 50px 0px rgba(51,51,51,0.1);
    border-radius:8px;
    display: flex;
    .img-wrap{
      width: 373px;
      height: 540px;
      margin: 15px 0 15px 15px;
      border-radius: 8px 0 0 8px;
      box-shadow:0px 5px 50px 0px rgba(51,51,51,0.1);
      img{
        width: 373px;
        height: 540px;
        display: block;
      }
    }
    .form-wrap{
      padding: 0 80px;
      flex: 1;
      position: relative;
      .img-logo {
        position: absolute;
        top: 26px;
      }
      .el-form{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 28px;
        .el-form-item{
          width: 100%;
          margin-bottom: 50px;
          &:last-of-type{
            margin-top: 25px;
            margin-bottom: 0;
          }
          .el-input{
            .el-input__inner{
              border-width: 0 0 1px 0!important;
              border-radius: 0!important;
              padding: 0 25px!important;
              font-size: 16px;
              &:focus{
                border-color: #4E646E!important;
              }
            }
            .el-input__prefix{
              left: 0;
            }
            .el-input__suffix{
              right: 0;
              cursor: pointer;
              .el-input__clear{
                display: none;
              }
            }
            .jee-svg-icon{
              fill: #AFAFAF;
            }
            &.is-focus,
            .el-input__suffix:hover{
              .jee-svg-icon{
                fill: #4E646E;
              }
            }
          }
          .el-form-item__error{
            left: 25px;
          }
          .submit{
            text-align: center;
            height: 45px;
            line-height: 45px;
            font-size: 18px;
            background-color: #4E646E;
            box-shadow:0px 3px 7px 0px rgba(85,110,121,0.25);
            border-radius:4px;
            cursor: pointer;
            color: #ffffff;
            &:hover{
              background-color: #59737E;
            }
            .logining{
              padding-left: 10px;
            }
            @keyframes rotate {
              from {
                transform: rotate(0);
              }
              to {
                transform: rotate(360deg);
              }
            }
            .loading{
              display: inline-block;
              animation: rotate 1s linear infinite;
              .jee-svg-icon{
                font-size: 20px;
                fill: #ffffff;
              }
            }
          }
          &.is-error .el-input__inner {
            border-color: #e8e8e8;
          }
        }
      }
    }
  }
  .register {
    display: block;
    text-align: right;
    cursor: pointer;
  }
  .register:hover {
    color: #4E646E;
  }
}
</style>
